var FreeShippingBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["shipping-threshold", "product-threshold", "total-price", "calculated-total-price", "second-product-threshold", "has-free-shipping-discount"];
  }
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
  }
  async connectedCallback() {
    const isMarket = (this.getAttribute('is-market') || '').toString().toLowerCase() === 'false' || this.getAttribute('is-market') === '0';
    if (isMarket) {
      const rate = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) ? Shopify.currency.rate : 1;
      this.shippingThreshold = Math.round(this.shippingThreshold * rate);
      this.productThreshold = Math.round(this.productThreshold * rate);
      if (!isNaN(this.secondProductThreshold)) {
        this.secondProductThreshold = Math.round(this.secondProductThreshold * rate);
      }
    }
    document.addEventListener("cart:change", this._onCartChangedListener);
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  get shippingThreshold() {
    return parseFloat(this.getAttribute("shipping-threshold"));
  }
  set shippingThreshold(value) {
    this.setAttribute("shipping-threshold", value);
  }
  get productThreshold() {
    return parseFloat(this.getAttribute("product-threshold"));
  }
  get secondProductThreshold() {
    return parseFloat(this.getAttribute("second-product-threshold"));
  }
  set productThreshold(value) {
    this.setAttribute("product-threshold", value);
  }
  set secondProductThreshold(value) {
    this.setAttribute("second-product-threshold", value);
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  get calculatedTotalPrice() {
    return parseFloat(this.getAttribute("calculated-total-price"));
  }
  set calculatedTotalPrice(value) {
    this.setAttribute("calculated-total-price", value);
  }
  get hasFreeShippingDiscount() {
    return this.getAttribute("has-free-shipping-discount") === "true";
  }
  // Skala der Bar = höchste Schwelle; die Versandgrenze kann über den Produkt-Schwellen liegen (z. B. CA)
  get maxThreshold() {
    return Math.max(
      this.shippingThreshold || 0,
      this.productThreshold || 0,
      this.secondProductThreshold || 0
    );
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "shipping-threshold":
      case "product-threshold":
      case "second-product-threshold":
        progressBarElement.valueMax = this.maxThreshold;
        break;
      case "total-price":
      case "calculated-total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    this._updateMessage();
    this._updateProgress();
  }
  /*_formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    
    const formatOptions = {
      style: 'currency',
      currency: Shopify.currency ? Shopify.currency.active : 'EUR'
    };
    
    return new Intl.NumberFormat('de-DE', formatOptions).format(cents / 100);
  }*/
  _formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  _updateProgress() {
    const progressBarElement = this.querySelector("progress-bar");

    // Check if there are no items requiring shipping
    const noShippingRequired = this.calculatedTotalPrice === 0;

    // Die Steps sitzen per CSS bei threshold / max-threshold, daher füllt sich die
    // Bar linear bis zur höchsten Schwelle – egal in welcher Reihenfolge
    // Versand- und Produkt-Schwellen liegen.
    const maxScale = this.maxThreshold;
    const shippingIsFree = noShippingRequired || this.hasFreeShippingDiscount;

    let effectiveTotal = this.totalPrice;
    if (shippingIsFree && this.shippingThreshold > 0 && this.shippingThreshold < maxScale) {
      // Versand ist bereits frei: Bar mindestens bis zum Versand-Step füllen,
      // aber nur wenn darüber noch weitere Schwellen liegen
      effectiveTotal = Math.max(effectiveTotal, this.shippingThreshold);
    }

    const progress = maxScale > 0 ? (effectiveTotal / maxScale) * 100 : 100;

    progressBarElement.style.setProperty('--progress', `${Math.min(100, Math.max(0, progress))}%`);

    const shippingStep = this.querySelector('.step-shipping');
    const productStep = this.querySelector('.step-product');
    const secondProductStep = this.querySelector('.step-second-product');

    if (shippingStep) {
      if (this.totalPrice >= this.shippingThreshold || noShippingRequired || this.hasFreeShippingDiscount) {
        shippingStep.classList.add('completed');
      } else {
        shippingStep.classList.remove('completed');
      }
    }

    if (productStep) {
      if (this.totalPrice >= this.productThreshold) {
        productStep.classList.add('completed');
      } else {
        productStep.classList.remove('completed');
      }
    }

    if (secondProductStep) {
      if (this.totalPrice >= this.secondProductThreshold) {
        secondProductStep.classList.add('completed');
      } else {
        secondProductStep.classList.remove('completed');
      }
    }
  }
  _updateMessage() {
    const messageElement = this.querySelector("span");
    if (!messageElement) return;

    const noShippingRequired = this.calculatedTotalPrice === 0;
    const replaceAmount = (template, cents) => {
      const replacement = `<span class="bold text-accent">${this._formatMoney(cents)}</span>`;
      // Use function form to avoid $-backreference issues in replacement strings
      return template.replace(/\{\{\s*.*?\s*\}\}/g, () => replacement);
    };
    if (this.totalPrice >= this.secondProductThreshold) {
      messageElement.innerHTML = this.getAttribute("second-product-reached-message");
    } else if (this.totalPrice >= this.productThreshold && this.totalPrice < this.secondProductThreshold) {
      const remaining = this.secondProductThreshold - this.totalPrice;
      messageElement.innerHTML = replaceAmount(this.getAttribute("second-product-unreached-message"), remaining);
      /*const replacement = `<span class="bold text-accent">${this._formatMoney(remaining)}</span>`;
      messageElement.innerHTML = this.getAttribute("second-product-unreached-message").replace(new RegExp("({{.*}})", "g"), replacement);*/
      
    } else if (this.totalPrice >= this.productThreshold) {
      messageElement.innerHTML = this.getAttribute("product-reached-message");
    } else if (this.totalPrice >= this.shippingThreshold || noShippingRequired || this.hasFreeShippingDiscount) {
      const remaining = this.productThreshold - this.totalPrice;
      messageElement.innerHTML = replaceAmount(this.getAttribute("product-unreached-message"), remaining);
    } else {
      const remaining = this.shippingThreshold - this.totalPrice;
      messageElement.innerHTML = replaceAmount(this.getAttribute("shipping-unreached-message"), remaining);
    }
  }
  _onCartChanged(event) {
    const cart = event.detail["cart"];
    this.totalPrice = cart["total_price"];
    this.calculatedTotalPrice = cart["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0);
  }
};

if (!window.customElements.get("free-shipping-bar")) {
  window.customElements.define("free-shipping-bar", FreeShippingBar);
}